import { Injectable } from "@angular/core";
import { finalize } from "rxjs";
import { HttpService } from "src/app/core";

@Injectable({
  providedIn: "root",
})
export class InterestsService extends HttpService {
  private _baseUrl = "usersubjects/";
  private set baseUrl(_baseUrl: string) {
    this._baseUrl = _baseUrl;
  }

  protected override get baseUrl(): string {
    return this._baseUrl;
  }

  getIntrests() {
    this.baseUrl = "subject/";
    return this.get<any[]>({ APIName: "getall" }).pipe(finalize(() => (this.baseUrl = "usersubjects/")));
  }

  addUserIntrests(body: any) {
    return this.post<any>({ APIName: "add", body });
  }

  getUserIntrests() {
    this.baseUrl = "usersubjects/";
    return this.get<any>({ APIName: `get-user-subjects` }).pipe(finalize(() => (this.baseUrl = "usersubjects/")));
  }

  updateUserIntrests(body: any) {
    return this.put<any>({ APIName: "update", body });
  }

  getIntrestsPercentage() {
    return this.get<any>({ APIName: "get-subject-percentage" });
  }
}
